import { Component, OnInit, ViewEncapsulation } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { environment } from 'src/environments/environment'
import { ArticleService } from '../../../services/article.service'
import { Meta, Title } from '@angular/platform-browser'
import { SeoService } from 'src/app/services/seo.service'
import { HttpClient } from '@angular/common/http'
import Swal from 'sweetalert2'
import { NgxSeoService } from '@avivharuzi/ngx-seo'

@Component({
  selector: 'app-blog-details',
  templateUrl: './blog-details.component.html',
  styleUrls: ['./blog-details.component.scss'],
})
export class BlogDetailsComponent implements OnInit {
  articleId: string
  article: any
  server: string = environment.blobURL
  latestArticles: any
  averageRating: number = 0 // Variable pour la note moyenne
  reviewsCount: number = 0 // Variable pour la note moyenne
  showReviewForm = false
  stars = Array(5).fill(0) // 5 étoiles
  fullStars: number[] = []
  halfStar: boolean = false
  emptyStars: number[] = []
  review = { email: '', rating: null, ip: '' }
  reviews: any[] = []
  reviewsToShow: any[] = []
  showReviews: boolean = false // Variable qui contrôle l'affichage des commentaires

  constructor (
    private articleService: ArticleService,
    private route: ActivatedRoute,
    private meta: Meta,
    private titleService: Title,
    private seoService: SeoService,
    private http: HttpClient,
    private ngxSeoService: NgxSeoService
  ) {}

  ngOnInit (): void {
    this.calculateStars()

    if (this.seoService.isServer()) {
      this.route.queryParams.subscribe(params => {
        this.meta.removeTag('description')

        this.articleId = params['id']
        this.getArticle(this.articleId)
        this.getArticleReviews() // Ajoutez ici l'appel pour récupérer les avis
      })
      this.getLatest()
    } else {
      this.route.queryParams.subscribe(params => {
        this.meta.removeTag('description')
        this.articleId = params['id']
        this.getArticle(this.articleId)
        this.getArticleReviews() // Ajoutez ici l'appel pour récupérer les avis
      })
      this.getLatest()
    }
    this.getUserIP() // Récupérer l'adresse IP du guest
  }
  calculateStars () {
    const rating = this.averageRating
    this.fullStars = Array(Math.floor(rating)).fill(0)
    this.halfStar = rating % 1 >= 0.5 // Corrigé : Une demi-étoile si la note est >= 0.5
    this.emptyStars = Array(5 - Math.ceil(rating)).fill(0)
  }

  getArticle = (articleId: string) =>
    this.articleService.getOne(articleId).subscribe((res: any) => {
      this.article = res.data
      this.articleService.getArticleStats(articleId).subscribe((resp: any) => {
        this.averageRating = resp.data.averageRating || 0 // Assurer une valeur par défaut
        this.reviewsCount = resp.data.reviewersCount || 0 // Récupérer le nombre de commentaires
      })

      this.calculateStars() // Suppose que `averageRating` est renvoyé par ton API

      if (this.article.pageTitle)
        this.titleService.setTitle(this.article.pageTitle)

      this.meta.removeTag('description')
      this.meta.removeTag('keywords')
      this.meta.removeTag('url')

      this.ngxSeoService.setMetaCustomTags([
        { name: 'description', content: this.article.pagedescription || '' },
        { name: 'keywords', content: this.article.keywords || '' },
        { name: 'url', content: this.article.url || '' },
      ])

      if (this.article.canonical) {
        // Canonical
        const link: HTMLLinkElement = this.createLinkElement()
        link.setAttribute('rel', 'canonical')
        link.setAttribute('href', this.article.canonical)
        document.head.appendChild(link)

        this.ngxSeoService.setMetaCanonical(this.article.canonical)
      }

      if (this.article.structuredData) {
        // Structured Data
        const script: HTMLScriptElement = this.createScriptElement()
        script.type = 'application/ld+json'
        script.text = JSON.stringify(this.article.structuredData)
        document.head.appendChild(script)
      }
    })

  getLatest = () =>
    this.articleService
      .getLatest()
      .subscribe((res: any) => (this.latestArticles = res.data))

  private createLinkElement (): HTMLLinkElement {
    const link: HTMLLinkElement = document.createElement('link')
    return link
  }

  private createScriptElement (): HTMLScriptElement {
    const script: HTMLScriptElement = document.createElement('script')
    return script
  }
  getUserIP () {
    this.http
      .get<{ ip: string }>('https://api64.ipify.org?format=json')
      .subscribe(res => {
        this.review.ip = res.ip
        console.log('ippppppppp', this.review.ip)
      })
  }
  setRating (rating: number) {
    this.review.rating = rating
  }

  submitReview (event: Event) {
    event.preventDefault()

    if (!this.review.rating) {
      Swal.fire({
        icon: 'warning',
        title: 'تنبيه',
        text: 'يرجى إعطاء تقييم قبل الإرسال!',
      })
      return
    }

    this.articleService.postReview(this.articleId, this.review).subscribe(
      () => {
        console.log('Données à envoyer:', this.review) // Vérification des données envoyées

        Swal.fire({
          icon: 'success',
          title: 'شكرا!',
          text: 'لقد تم إرسال تقييمكم بنجاح',
          confirmButtonText: 'إغلاق',
        })

        this.showReviewForm = false
        this.review = { email: '', rating: 0, ip: this.review.ip }
      },
      error => {
        console.error("Erreur lors de l'envoi du review", error)
        Swal.fire({
          icon: 'error',
          title: 'خطأ!',
          text: 'حدث خطأ أثناء إرسال التقييم. يرجى المحاولة مرة أخرى لاحقًا.',
        })
      }
    )
  }

  shareOnFacebook () {
    const url = encodeURIComponent(window.location.href) // L'URL de l'article
    //const url = encodeURIComponent('https://www.kharaaj.com/article/40ea11c2-529a-4292-9849-1b5ba6a3c699');

    window.open(`https://www.facebook.com/sharer.php?u=${url}`, '_blank')
  }

  shareOnTwitter () {
    const url = encodeURIComponent(window.location.href)
    const text = encodeURIComponent('Check out this article!')
    window.open(
      `https://twitter.com/intent/tweet?url=${url}&text=${text}`,
      '_blank'
    )
  }

  shareOnLinkedIn () {
    const url = encodeURIComponent(window.location.href)
    window.open(
      `https://www.linkedin.com/shareArticle?mini=true&url=${url}`,
      '_blank'
    )
  }

  shareByEmail () {
    const url = encodeURIComponent(window.location.href)
    //const url = encodeURIComponent('https://www.kharaaj.com/article/40ea11c2-529a-4292-9849-1b5ba6a3c699'); // L'URL de l'article en production

    const subject = encodeURIComponent('Check out this article!')
    window.open(`mailto:?subject=${subject}&body=${url}`, '_self')
  }
  getArticleReviews (): void {
    this.articleService.getArticleWithReviews(this.articleId).subscribe(
      res => {
        console.log('Données récupérées:', res) // Affiche les données récupérées
        this.reviews = res.data // Assure-toi que les avis existent
        console.log('revieeeeees', this.reviews) // Affiche les avis
        this.reviewsToShow = this.reviews.slice(0, 3) // Affiche seulement les 5 premiers commentaires
      },
      error => {
        console.error('Erreur lors de la récupération des avis:', error)
      }
    )
  }

  starsArray (rating: number): number[] {
    return new Array(5).fill(0).map((_, index) => (index < rating ? 1 : 0)) // Crée 5 étoiles, remplit avec 1 si l'indice est inférieur à la note
  }
  showMoreReviews () {
    this.reviewsToShow = this.reviews // Affiche tous les commentaires
  }
  toggleReviews () {
    this.showReviews = !this.showReviews
  }
}
